import React, { useState } from 'react';
import SuccessModal from './presentational/SuccessModel';
import { NavLink } from 'react-router-dom';
import { STEPS } from '../dataHelp';



const TRUST_ITEMS = ['100% Free', 'No strings attached', 'Results same day', 'In-person or online'];

const AssessmentSection = ({ bannerStyles }) => {
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({ name: '', email: '', phone: '' });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    const data = {
      studentFullName: form.name,
      studentDob: '',
      studentGrade: '',
      studentSchoolName: '',
      parentFullName: form.name,
      parentRelationship: '',
      parentPhone: form.phone,
      parentEmail: form.email,
      tutoringSchedule: '',
    };
    const url = 'https://script.google.com/macros/s/AKfycbwfYqCqUEYWyCBHok7N5WTMp67gKYINATDoJBh6EmKb0IHgV2WWCzatTrMlePbF5CQrqQ/exec';
    fetch(url, {
      method: 'POST',
      body: JSON.stringify(data),
      headers: { "Content-Type": "application/json" },
      mode: 'no-cors',
    }).then(() => {
      setShowModal(true);
      setForm({ name: '', email: '', phone: '' });
    }).catch((error) => {
      console.error('Error submitting form', error);
    }).finally(() => {
      setLoading(false);
    });
  };

  return (
    <>
      <div className="assessment-section" style={bannerStyles}>
        <div className="row justify-content-center">
          <div className="col-md-8 text-center">
            {/* <span className="badge-pill">⭐ 100% FREE · NO COMMITMENT REQUIRED</span> */}
            <h2 className="font-bold font-50 mt-3">Start With a Free <span className="text-primary">Math</span> Level Assessment</h2>
            <p className="font-18 mt-3 px-4">Not sure where your child stands? Our complimentary assessment pinpoints exactly where gaps exist — so we build the perfect personalized plan from day one.</p>
          </div>
          <div className="col-md-10 mt-4">
            <div className="row">
              {STEPS.map((step) => (
                <div className="col-md-3 mb-3" key={step.num}>
                  <div className="step-card">
                    <span className="step-num">{step.num}</span>
                    <h5 className="font-bold mt-2">{step.title}</h5>
                    <p className="font-14 mb0" style={{ color: '#b8bcd4' }}>{step.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="col-md-6 mt-4 px-0">
            <div className="assessment-form-card">
              <h4 className="font-bold text-center">🎯 Claim Your Free Assessment</h4>
              <p className="text-center text-muted mb-3">Takes 30 seconds. We'll confirm your spot within 24 hours.</p>
              <form onSubmit={handleSubmit}>
                <div className="row mt-3">
                  <div className="col-md-6 mb-3">
                    <label htmlFor="assessmentName" className="form-label">Full Name</label>
                    <input type="text" className="form-control" id="assessmentName" name="name" value={form.name} onChange={handleChange} required />
                  </div>
                  <div className="col-md-6 mb-3">
                    <label htmlFor="assessmentPhone" className="form-label">Phone Number</label>
                    <input type="tel" className="form-control" id="assessmentPhone" name="phone" value={form.phone} onChange={handleChange} required />
                  </div>
                  <div className="col-md-12 mb-3">
                    <label htmlFor="assessmentEmail" className="form-label">Email Address</label>
                    <input type="email" className="form-control" id="assessmentEmail" name="email" value={form.email} onChange={handleChange} required />
                  </div>
                </div>
                <div className="text-center mt-3">
                  <button type="submit" className="btn contantBtn px-4 py-2 font-bold" disabled={loading}>
                    {loading ? (
                      <><span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>Loading...</>
                    ) : 'Book Free Assessment →'}
                  </button>
                </div>
                <div className="text-center mt-1">
                  <span className="text-muted">— or —</span>
                  <br />
                  <NavLink to="/registration" className="text-primary font-bold font-14 mt-1 d-inline-block">Fill out the full booking form with student details ↓</NavLink>
                </div>
              </form>
            </div>
          </div>
          <div className="d-flex flex-wrap justify-content-center gap-3 mt-4">
            {TRUST_ITEMS.map((item) => (
              <div className="mb-2" key={item}>
                <span className="trust-badge">✓ {item}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
      <SuccessModal show={showModal} handleClose={() => setShowModal(false)} />
      {showModal && <div className="modal-backdrop fade show"></div>}
    </>
  );
};

export default AssessmentSection;
